import './Dropdown.scss';

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import DropdownContent from './DropdownContent';
import DropdownHead from './DropdownHead';

const Dropdown = props => {
	const {
		label,
		children,
		active: isActive,
		arrowPosition,
		onToggle,
		className,
		headClassName,
		transparent,
		headerInfo,
		closable
	} = props;
	const [active, setActive] = useState(isActive);

	useEffect(() => setActive(isActive), [isActive]);

	return (
		<div className={`react__dropdown ${className}`} data-testid='dropdown'>
			<DropdownHead
				active={active}
				arrowPosition={arrowPosition}
				className={headClassName}
				closable={closable}
				headerInfo={headerInfo}
				label={label}
				transparent={transparent}
				onClick={() => {
					if (closable) {
						setActive(!active);
						onToggle(!active);
					}
				}}
			/>
			<DropdownContent active={active}>{children}</DropdownContent>
		</div>
	);
};

Dropdown.propTypes = {
	active: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	arrowPosition: PropTypes.oneOf(['left', 'right']),
	children: PropTypes.any,
	onToggle: PropTypes.func,
	className: PropTypes.string,
	headClassName: PropTypes.string,
	transparent: PropTypes.bool,
	closable: PropTypes.bool,
	headerInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

Dropdown.defaultProps = {
	active: false,
	closable: true,
	transparent: false,
	label: '',
	arrowPosition: 'left',
	children: null,
	className: '',
	headClassName: '',
	headerInfo: null,
	onToggle: () => {}
};

export default Dropdown;
